<template >
	<div>
		<vs-table
			:hoverFlat="true"
			:notSpacer="true"
			:data="phases"
			class="sub-phase-table"
		>
			<template slot-scope="{data}">

				<tbody>
					<h4 class="mb-4 ml-4">
						Feladatok
					</h4>

					<vs-tr
						:data="phases"
						:key="index"
						v-for="(phase, index) in data"
					>
						<vs-td>
							<p class="product-name font-medium truncate">{{ phase.name }}</p>
						</vs-td>
						<vs-td class="whitespace-no-wrap">
							<div class="flex pull-right">
								<vx-tooltip text="Módosítás">
									<vs-button
										type="border"
										size="small"
										icon-pack="feather"
										icon="icon-edit"
										class="mr-2"
										color="dark"
										@click.stop="editPhase(phase)"
									></vs-button>
								</vx-tooltip>
								<vx-tooltip text="Törlés">
									<vs-button
										type="border"
										size="small"
										icon-pack="feather"
										icon="icon-trash-2"
										color="danger"
										class="mr-2"
										@click.stop="deletePhase(phase.id)"
									></vs-button>
								</vx-tooltip>
							</div>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import PhaseTable from '@/views/transaction-types/components/PhaseTable.vue'

export default {
	components: {
		PhaseTable
	},
	props: {
		phases: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			chartOptions: null
		}
	},
	watch: {
	},
	computed: {
	},
	methods: {
		addNewPhase() {
			this.method = 'new'
			this.currentPhase = {}
			this.editPhaseModal = true
			this.currentPhase.transactionTypeId = this.type.id
		},

		editPhase(data) {
			this.$emit('editPhase', data)
		},
		deletePhase(id) {
			console.log('Delete phase');
			this.$emit('deletePhase', id)
		},
		addPhase(id) {
			this.$emit('addPhase', id)
		},
		getStatusColor(status) {
			switch (status) {
				case 'in_progress':
					return 'warning'

				case 'done':
					return 'success'

				case 'obstacle':
					return 'danger'

				default:
					return 'dark'
			}
		}

	}
}
</script>
